import React from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { useToggleWishlistItem } from "../../hooks/useToggleWishlistItem";
import Icon from "../../../../../common/components/Icon/Icon";

interface WishlistToggleButtonProps {
  productId: number;
  className?: string;
}

const WishlistToggleButton: React.FC<WishlistToggleButtonProps> = ({
  productId,
  className,
}) => {
  const { t } = useTranslation();
  const {
    handleToggle,
    isInWishlist,
    isLoading: isTogglingWishlist,
  } = useToggleWishlistItem(productId);

  const isApprovedMember = Boolean(window.commonVariables?.isApprovedMember);
  const loginUrl = window.commonVariables?.loginUrl || "/login";

  const wishlistTitle = isInWishlist
    ? t("wishlistToggleButton.removeFromWishlistTitle", "Remove from Wishlist")
    : t("wishlistToggleButton.addToWishlistTitle", "Add to Wishlist");

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isApprovedMember) {
      e.preventDefault();
      e.stopPropagation();
      toast.error(
        t(
          "wishlist.loginRequired",
          "Favorilere eklemek için lütfen giriş yapın.",
        ),
      );
      setTimeout(() => {
        window.location.href = loginUrl;
      }, 1000);
      return;
    }
    handleToggle(e);
  };

  return (
    <button
      className={`wishlist-toggle-button ${className || ""} ${
        isInWishlist ? "is-active" : ""
      }`}
      aria-label={wishlistTitle}
      title={wishlistTitle}
      onClick={handleClick}
      disabled={isTogglingWishlist}
    >
      <Icon
        iconName={isInWishlist ? "heart-filled" : "heart-outline"}
        className={isInWishlist ? "icon--filled" : "icon--stroke-thick"}
      />
    </button>
  );
};

export default WishlistToggleButton;
